import React, { Component } from 'react';
import {
	Button,
	Container,
	Col,
	Form,
	FormGroup,
	FormText,
	Input,
	Label,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter
} from 'reactstrap';
import axios from 'axios';

class AdminHomeContainerForm extends Component {

	handleUploadChange = (e) => {
		e.preventDefault();

		const reader = new FileReader();
		const file = e.target.files[0];

		reader.onloadend = () => {
			this.setState({
				uploaded: true,
				img: {
					obj: file,
					srcPreview: reader.result
				}
			});
		}

    	reader.readAsDataURL(file);
	};

	handleHeaderChange = (e) => {
		this.setState({header: e.target.value});
	};

	handleBodyChange = (e) => {
		this.setState({body: e.target.value});
	};

	showImage = () => {
		if (!this.state.img.src && !this.state.uploaded) {
			return;
		}

		const showOptionImgExists = (
			<FormGroup tag="fieldset" row>
				<Col sm={10}>
					<FormGroup check>
						<Label check className="active">
							<Input type="radio" name="imgRadio" value="imgKeep" {...!this.state.uploaded && {checked: "checked"}} />{' '}
							Keep current image
						</Label>
						<Label check className="active">
							<Input type="radio" name="imgRadio" value="imgRemove" />{' '}
							Don't use any image
						</Label>
					</FormGroup>
				</Col>
			</FormGroup>
		);

		const showOptionImgUploaded = (
			<FormGroup check>
				<Label check>
					<Input type="checkbox" name="imgCheckbox" value="imgRemove" />{' '}
					Don't use an image (will remove preview image)
				</Label>
			</FormGroup>
		);

		if (this.state.uploaded) {
			return (
				<div>
					<FormGroup>
						<Label>Preview</Label>
						<img src={this.state.img.srcPreview} className="img-fluid" alt="" />
					</FormGroup>
					{this.state.img.src ? showOptionImgExists : showOptionImgUploaded}
				</div>
			)
		} else {
			return (
				<div>
					<FormGroup>
						<Label>Current</Label>
						<img src={this.state.img.src} className="img-fluid" alt="" />
					</FormGroup>
					{this.state.img.src ? showOptionImgExists : showOptionImgUploaded}
				</div>
			)
		}
	};

	toggleSaveModal = (postSuccess) => {
		this.setState({
			saveModal: !this.state.saveModal,
			modalSuccess: postSuccess
		});
	};

	removeChanges = () => {
		this.setState({
			uploaded: false,
			img: {
				obj: null,
				src: null,
				srcPreview: null
			},
			header: '',
			body: '',
			removeModal: !this.state.removeModal
		}, () => {
			document.getElementById("home-container-form").reset();
			this.post(null);
			this.toggleRemoveSuccessModal();
		});
	};

	toggleRemoveModal = () => {
		this.setState({
			removeModal: !this.state.removeModal
		});
	};

	toggleRemoveSuccessModal = () => {
		this.setState({
			removeSuccessModal: !this.state.removeSuccessModal
		});
	};

	get = () => {
		if (process.env.REACT_APP_FRONT_END === "true") {
			return;
		}
		axios.get('/api/home-container')
		.then((res) => {
			if (res) {
				// if (!res.data.success) {
				// 	return;
				// }
				// const reader = new FileReader();
				// const file = res.data.img;

				// const importAllImgs = (r) => {
				// 	return r.keys().map(r);
				// }

				// const imgs = importAllImgs(require.context('../img/uploads/home-container', false));
				// console.log(imgs);

				this.setState({
					uploaded: false,
					img: {
						obj: res.data.img,
						src: (res.data.img) ? 'data:' + res.data.img.mimetype + ';base64,' + res.data.img.buffer : null
						//(res.data.img) ? 'data:' + res.data.img.mimetype + ';base64,' + res.data.img.data : null
					},
					header: res.data.header,
					body: res.data.body
				});

				// this.loadImage(res.data.img);

				// this.setState({
				// 	uploaded: false,
				// 	img: {
				// 		obj: res.data.img,
				// 		src: 'data:' + res.data.img.mimetype + ';base64,' + res.data.img.data
				// 	},
				// 	header: res.data.header,
				// 	body: res.data.body
				// });
			}
		})
		.catch((err) => {

		});
	};

	post = (e) => {
		if (e) {
			e.preventDefault();
		}

		const handleModalSuccess = (e, postSuccess) => {
			if (e) {
				this.toggleSaveModal(postSuccess);
			} else {
				this.setState({
					modalSuccess: postSuccess
				});
			}
		}

		const data = new FormData();
		data.append('img', this.state.img.obj);
		data.append('header', this.state.header);
		data.append('body', this.state.body);

		const config = { headers: { 'Content-Type': 'multipart/form-data'} };
		axios.post('/api/home-container', data, config)
		.then((res) => {
			handleModalSuccess(e, true);
		})
		.catch((err) => {
			handleModalSuccess(e, false);
		});

		// const config = { headers: { 'Content-Type': 'multipart/form-data'} };
		// axios.post('/api/home-container', {
		// 	img: this.state.img.obj,
		// 	header: this.state.header,
		// 	body: this.state.body
		// })
		// .then((res) => {
		// 	console.log(res);
		// 	handleModalSuccess(e, true);
		// })
		// .catch((err) => {
		// 	console.log(err);
		// 	handleModalSuccess(e, false);
		// });
	};

	constructor(props) {
		super(props);

		this.state = {
			uploaded: false,
			img: {
				obj: null,
				src: null,
				srcPreview: null
			},
			header: '',
			body: '',
			saveModal: false,
			modalSuccess: false,
			removeModal: false,
			removeSuccessModal: false
		}
	}

	componentDidMount() {
		this.get();
	}

	render() {
		return (
				<Form id="home-container-form" onSubmit={(e) => this.post(e)}>
					<FormGroup tag="fieldset" row>
						<legend className="col-form-legend col-sm-2">Image</legend>
						<Col sm={10}>
							{ this.showImage() }
							<Label for="img">Upload Image</Label>
							<Input type="file" name="imgUpload" id="img" onChange={(e) => this.handleUploadChange(e)} />
							<FormText color="muted">
								Uploaded image will replace current preview image
							</FormText>
						</Col>
					</FormGroup>
					<FormGroup>
						<Label for="header">Header Content</Label>
						<Input type="text" name="headerContent" id="header" size="lg" value={this.state.header} onChange={(e) => this.handleHeaderChange(e)}  />
						<FormText color="muted">
							Leave blank to remove
						</FormText>
					</FormGroup>	
					<FormGroup>
						<Label for="body">Body Content</Label>
						<Input type="textarea" name="bodyContent" id="body" value={this.state.body} style={{"height": "150px"}} onChange={(e) => this.handleBodyChange(e)} />
						<FormText color="muted">
							Leave blank to remove
						</FormText>
					</FormGroup>
					<Button color="primary">Save Changes</Button>{' '}
					<Button color="danger" onClick={this.toggleRemoveModal}>Remove All Changes</Button>
					<Modal isOpen={this.state.saveModal} toggle={this.toggleSaveModal}>
						<ModalHeader toggle={this.toggleSaveModal}>Home Container</ModalHeader>
						<ModalBody>
							{this.state.modalSuccess ? (
								<div>Your changes have been saved.</div>
							) : (
								<div>ERROR: Could not save changes. Try again later.</div>
							)}
						</ModalBody>
						<ModalFooter>
							<Button color="primary" onClick={this.toggleSaveModal}>OK</Button>
						</ModalFooter>
					</Modal>
					<Modal isOpen={this.state.removeModal} toggle={this.toggleRemoveModal}>
						<ModalHeader toggle={this.toggleRemoveModal}>Home Container</ModalHeader>
						<ModalBody>
							<div>Are you sure you want to remove all changes? This will delete all content and set a default container.</div>
						</ModalBody>
						<ModalFooter>
							<Button color="danger" onClick={this.removeChanges}>Yes</Button>
							<Button color="primary" onClick={this.toggleRemoveModal}>No</Button>
						</ModalFooter>
					</Modal>
					<Modal isOpen={this.state.removeSuccessModal} toggle={this.toggleRemoveSuccessModal}>
						<ModalHeader toggle={this.toggleRemoveSuccessModal}>Home Container</ModalHeader>
						<ModalBody>
							{this.state.modalSuccess ? (
								<div>Your changes have been removed.</div>
							) : (
								<div>ERROR: Could not remove changes. Try again later.</div>
							)}
						</ModalBody>
						<ModalFooter>
							<Button color="primary" onClick={this.toggleRemoveSuccessModal}>OK</Button>
						</ModalFooter>
					</Modal>
				</Form>
		);
	}
}

export default AdminHomeContainerForm;


// WEBPACK FOOTER //
// ./src/admin-components/AdminHomeContainerForm.js